import React, { useMemo } from 'react';
import { Box, Grid2, Typography, CircularProgress } from '@mui/material';
import { Page_Padding } from '../../shared/constants';
import CustomDivider from '../../shared/utils/CustomDivider';
import SkillBoxProductCard from '../../shared/components/SkillBoxProductCard';
import { useAllSkillBoxProducts } from '../../assets/api/useGetApi';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useNavigate } from 'react-router-dom';
import { useSkillBoxWishlist } from '../../assets/nodeApi/getApi/getCommonApi';

const WishList = () => {
    const navigate = useNavigate();
    const { data: wishlistData, isLoading: isWishlistLoading } = useSkillBoxWishlist();
    const { data: allProductsData, isLoading: isProductsLoading } = useAllSkillBoxProducts();

    const wishlistProducts = useMemo(() => {
        const wishlistItems = wishlistData?.data || [];
        const allProducts = allProductsData?.data || [];
        
        // Extract product IDs from wishlist items
        const wishlistProductIds = wishlistItems.map(item => Number(item.product_id || item.productId || item.id));

        const matchedProducts = allProducts.filter(product => wishlistProductIds.includes(Number(product.id)));

        return matchedProducts.map((p) => ({
            ...p,
            course_name: p.course_name || p.title,
            image_small: p.image_small || p.image,
        }));
    }, [wishlistData, allProductsData]);

    return (
        <Box className="body contact_us" px={Page_Padding} sx={{ maxWidth: '1536px', mx: 'auto', pb: '4rem' }}>
            <Box sx={{ width: "100%", pt: "2rem" }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: "1.5rem" }}>
                    <Icon
                        icon="mdi:arrow-left"
                        width="28"
                        height="28"
                        style={{ cursor: "pointer", marginRight: "12px", color: "#333" }}
                        onClick={() => navigate(-1)}
                    />
                    <Typography variant="h5" sx={{ fontWeight: 600 }}>
                        My Wishlist
                    </Typography>
                </Box>

                {(isWishlistLoading || isProductsLoading) ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 5 }}>
                        <CircularProgress color="primary" />
                    </Box>
                ) : (
                    <Grid2 container spacing={{ xs: "1rem", md: "2rem" }} sx={{ paddingTop: "20px" }}>
                        {wishlistProducts.map((item, index) => (
                            <Grid2 size={{ xs: 6, sm: 4, md: 3, lg: 3 }} key={item?.slug || index}>
                                <SkillBoxProductCard item={item} />
                            </Grid2>
                        ))}
                        
                        {wishlistProducts.length === 0 && (
                            <Grid2 size={{ xs: 12, sm: 12, md: 12 }} sx={{ textAlign: "center", marginTop: "40px" }}>
                                <Icon
                                    icon="mingcute:heart-line"
                                    width="54"
                                    height="54"
                                    color="#999"
                                    style={{ flexShrink: 0, marginBottom: "10px" }}
                                />
                                <Typography variant='h6' sx={{ color: "#555" }}>Your wishlist is empty</Typography>
                                <Typography variant='body2' sx={{ color: "#777", mt: 1 }}>
                                    Explore products and add your favorite items here!
                                </Typography>
                            </Grid2>
                        )}
                    </Grid2>
                )}
            </Box>
            <CustomDivider />
        </Box>
    );
};

export default WishList;